var exports = {
  "_": "xcc377c0b--905f2a--statItem",
};

module.exports = exports;
